// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"c38a417c","113":"317fd96b","142":"f25ff38f","189":"44ae7d2c","246":"0a44341b","279":"f00f726f","347":"dbd77e2f","421":"c236bc20","453":"6caeb43f","513":"d2010d36","556":"6679eae6","587":"ebeb065b","766":"f7cb4c76","783":"52c0cd35","796":"167ede00","905":"e4daf66c"}[chunkId] + ".chunk.js";
};